import { COMPANY } from "../constants";
import { instance } from "../../axios";
import { store } from "../../store";

let getCompaniesAction = () => {
  return (dispatch) => {
    dispatch({
      type: COMPANY.GET_COMPANIES,
    });
    instance
      .get(
        `/company?limit=${store.getState().patient.limit}&offset=${
          store.getState().patient.offset
        }&query=${encodeURI(store.getState().patient.query)}`
      )
      .then((results) => {
        dispatch({
          type: COMPANY.GET_COMPANIES_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: COMPANY.GET_COMPANIES_FAILURE,
          payload: error,
        });
      });
  };
};

let getCompanyAction = (id) => {
  return (dispatch) => {
    dispatch({
      type: COMPANY.GET_COMPANY,
    });
    instance
      .get("/company/" + id)
      .then((results) => {
        dispatch({
          type: COMPANY.GET_COMPANY_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: COMPANY.GET_COMPANY_FAILURE,
          payload: error,
        });
      });
  };
};

let createCompanyAction = (body) => {
  return (dispatch) => {
    dispatch({
      type: COMPANY.CREATE_COMPANY,
    });
    instance
      .post("/company", body)
      .then((results) => {
        dispatch({
          type: COMPANY.CREATE_COMPANY_SUCCESS,
          payload: results.data,
        });
        dispatch(getCompaniesAction());
      })
      .catch((error) => {
        dispatch({
          type: COMPANY.CREATE_COMPANY_FAILURE,
          payload: error,
        });
      });
  };
};

let updateCompanyAction = (body) => {
  return (dispatch) => {
    dispatch({
      type: COMPANY.CREATE_COMPANY,
    });
    instance
      .post("/company/" + body.id, body)
      .then((results) => {
        dispatch({
          type: COMPANY.CREATE_COMPANY_SUCCESS,
          payload: results.data,
        });
        dispatch(getCompaniesAction());
      })
      .catch((error) => {
        dispatch({
          type: COMPANY.CREATE_COMPANY_FAILURE,
          payload: error,
        });
      });
  };
};

let deleteCompanyAction = (id) => {
  return (dispatch) => {
    dispatch({
      type: COMPANY.GET_COMPANY,
    });
    instance
      .delete("/company/" + id)
      .then((results) => {
        dispatch({
          type: COMPANY.GET_COMPANY_SUCCESS,
          payload: results.data,
        });
        dispatch(getCompaniesAction());
      })
      .catch((error) => {
        dispatch({
          type: COMPANY.GET_COMPANY_FAILURE,
          payload: error,
        });
      });
  };
};

let setOffset = (offset) => {
  return (dispatch) => {
    dispatch({
      type: COMPANY.SET_OFFSET,
      payload: offset,
    });
    dispatch(getCompaniesAction());
  };
};

let setQuery = (query) => {
  return (dispatch) => {
    dispatch({
      type: COMPANY.SET_QUERY,
      payload: query,
    });
    dispatch(getCompaniesAction());
  };
};

let cleanCompanyAction = () => {
  return (dispatch) => {
    dispatch({
      type: COMPANY.CLEAN_COMPANY,
    });
  };
};

let cleanCompanyErrorAction = () => {
  return (dispatch) => {
    dispatch({
      type: COMPANY.CLEAN_ERROR,
    });
  };
};

export {
  getCompaniesAction,
  createCompanyAction,
  cleanCompanyAction,
  getCompanyAction,
  updateCompanyAction,
  deleteCompanyAction,
  setOffset,
  setQuery,
  cleanCompanyErrorAction,
};
